import React from 'react';

import { useFullVariantByIdSsr } from '../../../api/hooks/useFullVariantByIdSsr.hook';
import { useVariantDetailPage } from '../../../api/hooks/useVariantDetailPage.hook';
import { TypographyVariantsEnum } from '../../../utils/_enums/typeography-variants.enum';
import { getLanguage } from '../../../utils/_helper/locale-helper';
import { Typography } from '../../_shared/typography/typography';
import styles from './publisher-info-box.module.scss';
import { Media } from '../../_shared/media/media';

interface PublisherInfoBoxProps {
    className?: string;
}

const PublisherInfoBox = (props: PublisherInfoBoxProps) => {
    const data = useVariantDetailPage();
    const fullVariant = useFullVariantByIdSsr();
    const { product, publisher } = {
        product: fullVariant?.product,
        publisher: fullVariant?.publisher
    };

    if (product && publisher) {
        const lang = getLanguage();
        const langDependendDescription = (lang === 'de' ? publisher?.detailedDescriptionDe : publisher?.detailedDescription )
        
        return (
            <div
                className={`${styles['publisher-info-box']} ${
                    props.className ?? ''
                }`}
            >
                <div className={styles['publisher-info-box-inner-wrapper']}>
                    <Typography
                        className={styles['headline']}
                        variant={TypographyVariantsEnum.HEADING3_BOLD}
                    >
                        {data?.publisherHeadline.headlineContent}
                    </Typography>
                    <div className={styles['lower-wrapper']}>
                        <div className={styles['lower-wrapper-left']}>
                            <Typography
                                variant={TypographyVariantsEnum.HEADING6}
                            >
                                {publisher.companyName}
                            </Typography>
                            <Typography
                                variant={TypographyVariantsEnum.BODY}
                                className={`${styles['publisher-description']} ${styles['description-body']}`}
                            >
                                {langDependendDescription ?? ''}
                            </Typography>
                        </div>
                        {product.publisherImageUrl && (
                            <div className={styles['lower-wrapper-right']}>
                                <Media
                                    className={styles['publisher-logo']}
                                    objectFit={'contain'}
                                    src={product.publisherImageUrl}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    } else {
        return <div />;
    }
};
export default PublisherInfoBox;
